/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_UnavailableInputs */

const fr_api_drive_unavailable = /** @type {(inputs: Api_Drive_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de joindre Drive. Réessayez dans un instant.`)
};

const en_api_drive_unavailable = /** @type {(inputs: Api_Drive_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach Drive. Try again shortly.`)
};

/**
* | output |
* | --- |
* | "Could not reach Drive. Try again shortly." |
*
* @param {Api_Drive_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_unavailable = /** @type {((inputs?: Api_Drive_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_unavailable(inputs)
	return fr_api_drive_unavailable(inputs)
});